import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { RosterRunHistory } from "@app/models/rest/roster/roster-run-history";
import { RosterRunHistoryRestService } from "@app/services/hal/roster/roster-run-history-rest-service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class RosterRunHistoryStore extends RealTimeDataStore<RosterRunHistory> {
  constructor() {
    const rosterRunHistoryRestService = inject(RosterRunHistoryRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      rosterRunHistoryRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("RosterRunHistory");
  }
}
